function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("defs", null, React.createElement("path", {
  id: "heart_svg__a",
  d: "M888.182 492.16a.483.483 0 10.002.966.483.483 0 00-.002-.966z"
}), React.createElement("path", {
  id: "heart_svg__b",
  d: "M880.055 510.371c-6.446-5.587-11.39-9.6-11.39-13.996 0-3.277 2.256-5.748 5.248-5.748 1.662 0 3.121.618 4.338 1.837a7.207 7.207 0 011.364 1.886.483.483 0 00.88 0c.005-.01.437-.957 1.364-1.886 1.217-1.22 2.676-1.837 4.338-1.837 2.992 0 5.248 2.471 5.248 5.748 0 4.495-5.27 8.692-11.39 13.996zm10.63-18.7a5.933 5.933 0 00-4.496-2.011c-1.912 0-3.657.743-5.045 2.147a8.563 8.563 0 00-1.094 1.364 8.57 8.57 0 00-1.094-1.364c-1.388-1.404-3.133-2.147-5.045-2.147-3.66 0-6.211 3.068-6.211 6.715 0 4.927 5.21 9.075 12.034 15a.48.48 0 00.632 0c6.84-5.939 12.034-10.08 12.034-15 0-1.788-.609-3.459-1.715-4.704z"
}), React.createElement("path", {
  id: "heart_svg__c",
  d: "M889.864 493.879a.482.482 0 10-.854.449c.318.608.494 1.335.494 2.046 0 1.397-.664 2.88-2.088 4.666a.482.482 0 10.754.604c1.568-1.968 2.298-3.642 2.298-5.27 0-.877-.208-1.74-.604-2.495z"
}), React.createElement("path", {
  id: "heart_svg__d",
  d: "M884.203 501.82h-2.702a.483.483 0 00-.482.484v2.707h-1.93v-2.707a.483.483 0 00-.483-.483h-2.702v-1.934h2.702a.483.483 0 00.483-.483v-2.707h1.93v2.707c0 .267.216.483.482.483h2.702zm.482-2.9h-2.702v-2.707a.483.483 0 00-.482-.483h-2.895a.483.483 0 00-.482.483v2.707h-2.702a.483.483 0 00-.482.484v2.9c0 .267.216.484.482.484h2.702v2.707c0 .267.216.483.482.483h2.895a.483.483 0 00.482-.483v-2.707h2.702a.483.483 0 00.482-.484v-2.9a.483.483 0 00-.482-.484z"
}));

var _ref2 = /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#heart_svg__a",
  transform: "translate(-867 -489)"
});

var _ref3 = /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#heart_svg__b",
  transform: "translate(-867 -489)"
});

var _ref4 = /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#heart_svg__c",
  transform: "translate(-867 -489)"
});

var _ref5 = /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#heart_svg__d",
  transform: "translate(-867 -489)"
});

var SvgHeart = function SvgHeart(props) {
  return React.createElement("svg", _extends({
    width: 26,
    height: 23,
    viewBox: "0 0 26 23"
  }, props), _ref, _ref2, _ref3, _ref4, _ref5);
};

export default SvgHeart;